
import Vue from 'vue';
export default Vue.extend({
  name: 'FilArianne',
  computed: {
    parts: {
      get () {
        return this.$route.matched
          .filter(i => !!i.meta.title)
          .map(r => ({ route: r.name, libelle: r.meta.title }));
      }
    }
  },
  methods: {
    goMonAgrial () {
      const url = window.PROPERTIES.get('agrial.portail.url');
      if (url) {
        window.location.href = url as any;
      }
    }
  }
});
